import React from 'react';
import {Text4} from "../../../../libs/uiKit/globalStyledComponents";
import {NewArrowIcon} from "../../../../libs/uiKit/icons/NewArrow";
import {NewStyledBankTableColumns, StyledText4Oms} from "./styles";

const CollapsibleTable: React.FC<{
    header1: string;
    header2: string;
    children: React.ReactNode;
    isOpen: boolean;
    afterHeader?: React.ReactNode;
    headerColor?: string;
}> = ({ header1, header2, children, isOpen, afterHeader, headerColor }) => {

    const [stateIsOpen, setIsOpen] = React.useState(isOpen);

    return <>
        <NewStyledBankTableColumns>
            <Text4 className="bold header pointer"
                   onClick={() => setIsOpen(!stateIsOpen)}
                   style={{gridColumn: "1 / -2", whiteSpace: "nowrap", color: headerColor}}>
                {header1}
                <div style={{display: "inline-block", marginLeft: "1rem"}}>
                    <NewArrowIcon direction={stateIsOpen ? "up" : "down"} />
                </div>
                {afterHeader}
            </Text4>
            <Text4 className="right bold header" style={{color: headerColor}}>{header2}</Text4>
        </NewStyledBankTableColumns>
        {stateIsOpen && children}
    </>;
};

export default React.memo(CollapsibleTable);